import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { defaultDialogButtons, DialogData } from '../dialog-data.class';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false
})
/**
 * Component should be called with a button array following the specific structure.
 * The "onClick" return should be the index of the button. All specific logic should be handled by the caller.
 */
export class ModalComponent {
  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    data.buttons = data.buttons ? data.buttons : defaultDialogButtons;
    this.data = data;
  }

  /**
   * Returns the index of the pressed button. This should be used by the subscriber function to identify the button
   * @param buttonIndex the index of the pressed button
   */
  btnCallback(buttonIndex: number): void {
    this.dialogRef.close(buttonIndex);
  }

}
